module.exports = __webpack_public_path__ + "img/744.fc52fd57.jpg";